// extracted by mini-css-extract-plugin
export default {"shoppingCartListItem":"ShoppingList_shoppingCartListItem__PKGiV"};